import { ArticlePara } from '../PaywallSniperStyles';
import * as React from 'react';

export const generateArticle = (rawContent: string) => {
	// Normalize newlines:
	// 1) Convert CRLF -> LF
	// 2) Convert escaped sequences "\\n" (literal backslash+n) into real newlines
	let normalized = rawContent.replace(/\r\n/g, '\n');
	normalized = normalized.replace(/\\n/g, '\n');

	// Split into paragraphs by blank lines (two or more newlines, possibly with spaces).
	// If that results in a single paragraph but there are single newlines, fall back to splitting on single newline.
	let paragraphs = normalized.split(/\n\s*\n+/);
	if (paragraphs.length === 1 && normalized.indexOf('\n') !== -1) {
		paragraphs = normalized.split(/\n/);
	}

	// Trim and remove empty paragraphs
	paragraphs = paragraphs.map((p) => p.trim()).filter((p) => p.length > 0);

	// Logging for debugging (keep existing detailed logs but show normalized form)
	const escaped = JSON.stringify(rawContent);
	const visible = rawContent.replace(/\n/g, '\\n');
	const decoded = normalized; // now contains actual newlines
	const encoder = new TextEncoder();
	const bytes = Array.from(encoder.encode(rawContent))
		.map((b) => b.toString(16).padStart(2, '0'))
		.join(' ');
	const codepoints = Array.from(rawContent)
		.map((ch) => 'U+' + (ch.codePointAt(0) || 0).toString(16).toUpperCase())
		.join(' ');

	console.log('----- rawContent encoding start -----');
	console.log('escaped (JSON.stringify):', escaped);
	console.log("visible (show literal '\\n' sequences):", visible);
	console.log('normalized (with actual newlines):\n' + decoded);
	console.log('utf8 bytes (hex):', bytes);
	console.log('unicode code points:', codepoints);
	console.log('----- rawContent encoding end -----');

	// Return an array of paragraphs as ArticlePara elements
	const returnValue = paragraphs.map((para, idx) => {
		const returnValue = <ArticlePara key={idx}>{para}</ArticlePara>;
		return returnValue;
	});
	return returnValue;
};
